"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChipInputComponent = void 0;
var _index = require("../Chip/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var _index2 = require("../../styles/index.js");
var closeIconHoverScale = 1.17;
var ChipInputComponent = exports.ChipInputComponent = (0, _styledComponents["default"])(_index.Chip).withConfig({
  displayName: "ChipInput__ChipInputComponent",
  componentId: "sc-14a5x4o-0"
})(["svg{transition-duration:", ";transition-timing-function:", ";", "}&:hover,&:focus{svg{transform:scale(", ");}}"], _index2.durationMedium, _index2.advanceFierce, _index2.prefersReducedMotion, closeIconHoverScale);